<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <PropertyAssetStatisticSummary ref="propertyAssetStatisticSummary" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <PropertyTypeStatisticSummary style="height: 300px;" ref="propertyTypeStatisticSummary" />
            </div>
            <div class="col-md-6">
                <PropertyActionStatisticSummary style="height: 300px;" ref="propertyActionStatisticSummary" />
            </div>
        </div>
        <div class="card">
            <div class="card-body mb-0 pb-0">
                <TabNavigation
                    v-if="status.list"
                    v-model="activeTab"
                    :tabs="tabs"
                    class="mb-2"
                    @input="changeTab"
                />
                <div v-else class="d-flex justify-content-center align-items-center m-5 p-5">
                    <b-spinner class="m-5" variant="info" role="status"></b-spinner>
                </div>
                <PropertyAssetListing
                    v-if="showListing"
                    :propertyStatus="activeTab"
                    class="fade-in"
                    @done="getPropertyStatusList(searchCriteria)"
                    @saved="refreshStatisticSummary"
                />
            </div>
        </div>
    </Layout>
</template>
<script>
import PropertyActionStatisticSummary from "@/views/pages/admin/propertyAction/propertyActionStatisticSummary";
import PropertyAssetStatisticSummary from "@/views/pages/admin/propertyAsset/propertyAssetStatisticSummary";
import PropertyTypeStatisticSummary from "@/views/pages/admin/propertyType/propertyTypeStatisticSummary";
import TabNavigation from "@/components/customTopNav";
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import { SESSION } from "@/constants";
import { sessionHelper, ddlHelper } from "@/utils";
import { mapState } from "vuex";
import { propertyStatusMethods } from "@/state/api";
import { PROPERTY_STATUS_MODULE } from "@/state/api/propertyStatus.state";
import PropertyAssetListing from "@/views/pages/admin/propertyAsset/propertyAssetListing";

export default {
    page: {
        title: i18n.t("label.asset"),
    },
    components: { Layout, PageHeader, PropertyAssetListing, TabNavigation, PropertyActionStatisticSummary, PropertyAssetStatisticSummary, PropertyTypeStatisticSummary },
    created() {
        sessionHelper.clearSearch(SESSION.PROPERTY_STATUS_SEARCH) // clear search whenever page reload
        this.initSearchCriteria();
    },
    data() {
        return {
            title: i18n.t("label.asset"),
            items: [
                {
                    text: i18n.t("module.property"),
                    href: '/properties',
                },
                {
                    text: i18n.t("label.asset"),
                    active: true,
                },
            ],
            statusDdl: ddlHelper.getActivationStatus(true),
            isActive: ddlHelper.getActivationStatus(true)[1],
            tabs: [],
            activeTab: null,
            showListing: false,
        };
    },
    methods: {
        ...propertyStatusMethods,
        refreshStatisticSummary() {
            this.$refs.propertyAssetStatisticSummary.getPropertyAssetStatisticSummary();
            this.$refs.propertyTypeStatisticSummary.getPropertyTypeStatisticSummary();
            this.$refs.propertyActionStatisticSummary.getPropertyActionStatisticSummary();
        },
        initSearchCriteria() {
            let isDefault = true;
            if(sessionHelper.hasSearchCriteria(SESSION.PROPERTY_STATUS_SEARCH)) {
                isDefault = false;
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.PROPERTY_STATUS_SEARCH);
            }
            if(isDefault) {
                this.searchCriteria = {
                    showNa: 1, // show N/A status
                    isActive: this.isActive.value,
                };
            }
            this.getPropertyStatusList(this.searchCriteria);
        },
        getPropertyStatusList(filter) {
            this.getAllPropertyStatus({filter})
                .then((result) => {
                    if (result?.success) {
                        this.tabs = this.tableRows.map((item) => ({
                            id: item.uuid,
                            name: item.name,
                            count: item.propertyCount,
                        }));
                        this.activeTab = this.tabs.find((item) => item.id == this.activeTab)?.id || this.tabs[0]?.id;
                        this.showListing = true;
                    }
                });
            this.searchCriteria = filter;
            sessionHelper.storeSearch(SESSION.PROPERTY_STATUS_SEARCH, filter);
        },
        changeTab() {
            this.showListing = false;
            this.$nextTick(() => {
                this.showListing = true;
            });
        },
    },
	computed: {
        ...mapState(PROPERTY_STATUS_MODULE, ['status']),
		tableRows() {
			return this.$store.state.api.propertyStatus.list.data || [];
		},
	},
}
</script>
